const API_URL = "https://blog.purvsoft.com/api";
export default API_URL;

export const imageBaseURL = "https://blog.purvsoft.com/";